import React, {useEffect, useState} from "react";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { CardActions, Grid, Snackbar } from "@material-ui/core";
import { MUIInput, MUIAutoComplete } from "../../utils/formUtils";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Spinner from "../../components/Spinner";
import axiosInstance from "../../api";
import addressData from "../../data/addressData.json";
import { Alert } from "@material-ui/lab";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

const validationSchema = yup.object().shape({
  email: yup
      .string()
      .email("Email should be in valid format")
      .lowercase()
      .required("Please complete all required fields")
      .nullable(),
  emailCopy: yup
      .string()
      .email("Email should be in valid format")
      .lowercase()
      .oneOf([yup.ref("email"), ""], "Email must match")
      .required("Please complete all required fields")
      .nullable(),
  firstName: yup
      .string()
      .required("Please complete all required fields")
      .nullable(),
  lastName: yup
      .string()
      .required("Please complete all required fields")
      .nullable(),
  mobilePhone: yup
      .string()
      .phone("US", false, "Primary phone must be a valid US phone number")
      .required("Please complete all required fields")
      .nullable(),
  mailingAddressLine1: yup.string().when("isMailingSameAsProperty", {
    is: (isMailingSameAsProperty) => isMailingSameAsProperty === false,
    then: yup
        .string()
        .required("Please complete all required fields")
        .nullable(),
    otherwise: yup.string().nullable(),
  }),
  mailingCity: yup.string().when("isMailingSameAsProperty", {
    is: (isMailingSameAsProperty) => isMailingSameAsProperty === false,
    then: yup
        .string()
        .required("Please complete all required fields")
        .nullable(),
    otherwise: yup.string().nullable(),
  }),
  mailingState: yup
      .string()
      .when(["isMailingSameAsProperty", "mailingCountry"], {
        is: (isMailingSameAsProperty, mailingCountry) =>
            isMailingSameAsProperty === false &&
            mailingCountry === "United States of America",
        then: yup
            .string()
            .required("Please complete all required fields")
            .nullable(),
        otherwise: yup.string().nullable(),
      }),
  mailingZip: yup.string().when("isMailingSameAsProperty", {
    is: (isMailingSameAsProperty) => isMailingSameAsProperty === false,
    then: yup
        .string()
        .required("Please complete all required fields")
        .nullable(),
    otherwise: yup.string().nullable(),
  }),
});
export default function LeadContactDetailsViewEditTile({
                                                         consumerData,
                                                         hasWithdrawn,
                                                         setConsumerData,
                                                       }) {

  const classes = useStyles();
  const [editContact, setEditCoontact] = useState(false);
  const [contactInfo, setContactInfo] = useState({
    email: consumerData?.email,
    mobilePhone: consumerData?.mobilePhone,
    reEnterEmail: null,
    firstName: consumerData?.firstName,
    lastName: consumerData?.lastName,
    mailingAddressLine1: consumerData?.mailingAddressLine1,
    mailingAddressLine2: consumerData?.mailingAddressLine2,
    mailingCity: consumerData?.mailingCity,
    mailingState: consumerData?.mailingState,
    mailingZip: consumerData?.mailingZip,
    county: consumerData?.county,
    country: consumerData?.country,
  });
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(validationSchema) });
  const [showSpinner, setShowSpinner] = useState(false);
  const [snackBarSettings, setSnackBarSettings] = useState({
    show: false,
    message: null,
    variant: "success",
  });
  const [countryList, setCountryList] = useState([]);
  const [isAddressStandardized, setIsAddressStandardized] = useState(false);
  useEffect(() => {
    // Anything in here is fired on component mount.
    // fetching static data
    //let countryList = ['Out of Florida', ...addressData.countryList];
    setCountryList(addressData.countryList);
  }, []);

  function blockFieldCopy(event) {
    event.preventDefault();
  }

  const onSubmit = (data) => {
    updContact();
  };

  const updContact = () => {
    setShowSpinner(true);
    setIsAddressStandardized(false);
    axiosInstance
        .post("unauth/leads/updateContact", {
          contactId: consumerData?.contactId,
          cellPhoneNumber: contactInfo?.mobilePhone,
          email: contactInfo?.email,
          nonce: consumerData?.nonce,
          createdAt: consumerData?.createdAt,
          userRequestId: consumerData?.userRequestId,
          firstName: contactInfo?.firstName,
          lastName: contactInfo?.lastName,
          mailingAddressLine1: contactInfo?.mailingAddressLine1,
          mailingAddressLine2: contactInfo?.mailingAddressLine2,
          mailingCity: contactInfo?.mailingCity,
          mailingState: contactInfo?.mailingState,
          mailingZip: contactInfo?.mailingZip,
          mailingCounty:contactInfo?.county,
          mailingCountry:contactInfo?.country,
          isAddressStandardized:isAddressStandardized
        })
        .then((data) => {
          setSnackBarSettings({
            show: true,
            message: "Contact Details updated successfully!",
            variant: "success",
          });
          setEditCoontact(false);
          // post to parent
          setConsumerData((prevState) => {
            let newState = Object.assign({}, prevState);
            newState["email"] = contactInfo?.email;
            newState["mobilePhone"] = contactInfo?.mobilePhone;
            newState["firstName"] = contactInfo?.firstName;
            newState["lastName"] = contactInfo?.lastName;
            newState["mailingAddressLine1"] = contactInfo?.mailingAddressLine1;
            newState["mailingAddressLine2"] = contactInfo?.mailingAddressLine2;
            newState["mailingCity"] = contactInfo?.mailingCity;
            newState["mailingState"] = contactInfo?.mailingState;
            newState["mailingZip"] = contactInfo?.mailingZip;

            return newState;
          });
        })
        .catch((err) =>
            setSnackBarSettings({
              show: true,
              message:
                  "An error occured while updating contact details. Please try again later.",
              variant: "error",
            })
        )
        .finally(() => setShowSpinner(false));
  };

  const handleSnackBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackBarSettings({ show: false, message: null, variant: "" });
  };

  if (showSpinner) return <Spinner />;

  return (
      <section>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Card className={classes.root} variant="outlined">
            <CardContent>
              <Typography variant="h5" component="h2">
                Contact Details
              </Typography>
              <Grid container spacing={2}>
                {" "}
                {!editContact && (
                    <>
                      <Grid item xs={12} sm={6} md={4}>
                        Name: <br />
                        <b>{consumerData?.firstName}</b>{" "}
                        <b>{consumerData?.lastName}</b>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        Mailing Address: <br />
                        <b>
                          <span>{consumerData?.mailingAddressLine1}</span>&nbsp;
                          <span>{consumerData?.mailingAddressLine2}</span>
                          <br />
                          <span>{consumerData?.mailingCity}</span>,{" "}
                          <span>{consumerData?.mailingState}</span>,{" "}
                          <span>{consumerData?.mailingZip}</span>
                        </b>
                      </Grid>

                      <Grid item xs={12} sm={6} md={4}>
                        Email: <br />
                        <b>{consumerData?.email}</b>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        Primary Phone Number: <br />
                        <b>{consumerData?.mobilePhone}</b>
                      </Grid>
                    </>
                )}
                {editContact && (
                    <>
                      <Grid item xs={12} sm={6} md={4}>
                        <MUIInput
                            control={control}
                            name="firstName"
                            onInputCopy={blockFieldCopy}
                            onInputCut={blockFieldCopy}
                            defaultValue={contactInfo?.firstName}
                            inputPrp={{ maxLength: 100 }}
                            value={contactInfo?.firstName}
                            label="First Name"
                            onInputChange={(event) =>
                                setContactInfo(
                                    Object.assign({}, contactInfo, {
                                      firstName: event.target.value,
                                    })
                                )
                            }
                            errors={errors}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <MUIInput
                            control={control}
                            name="lastName"
                            onInputCopy={blockFieldCopy}
                            onInputCut={blockFieldCopy}
                            defaultValue={contactInfo?.lastName}
                            inputPrp={{ maxLength: 100 }}
                            value={contactInfo?.lastName}
                            label="Last Name"
                            onInputChange={(event) =>
                                setContactInfo(
                                    Object.assign({}, contactInfo, {
                                      lastName: event.target.value,
                                    })
                                )
                            }
                            errors={errors}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <MUIInput
                            control={control}
                            name="mailingAddressLine1"
                            onInputCopy={blockFieldCopy}
                            onInputCut={blockFieldCopy}
                            defaultValue={contactInfo?.mailingAddressLine1}
                            inputPrp={{ maxLength: 80 }}
                            value={contactInfo?.mailingAddressLine1}
                            label="Mailing Address Line1"
                            onInputChange={(event) =>
                                setContactInfo(
                                    Object.assign({}, contactInfo, {
                                      mailingAddressLine1: event.target.value,
                                    })
                                )
                            }
                            errors={errors}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <MUIInput
                            control={control}
                            name="mailingAddressLine2"
                            onInputCopy={blockFieldCopy}
                            onInputCut={blockFieldCopy}
                            defaultValue={contactInfo?.mailingAddressLine2}
                            inputPrp={{ maxLength: 80 }}
                            value={contactInfo?.mailingAddressLine2}
                            label="Mailing Address Line2"
                            onInputChange={(event) =>
                                setContactInfo(
                                    Object.assign({}, contactInfo, {
                                      mailingAddressLine2: event.target.value,
                                    })
                                )
                            }
                            errors={errors}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <MUIInput
                            control={control}
                            name="mailingCity"
                            onInputCopy={blockFieldCopy}
                            onInputCut={blockFieldCopy}
                            defaultValue={contactInfo?.mailingCity}
                            inputPrp={{ maxLength: 50 }}
                            value={contactInfo?.mailingCity}
                            label="Mailing City"
                            onInputChange={(event) =>
                                setContactInfo(
                                    Object.assign({}, contactInfo, {
                                      mailingCity: event.target.value,
                                    })
                                )
                            }
                            errors={errors}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <MUIInput
                            control={control}
                            name="mailingState"
                            onInputCopy={blockFieldCopy}
                            onInputCut={blockFieldCopy}
                            defaultValue={contactInfo?.mailingState}
                            inputPrp={{ maxLength: 50 }}
                            value={contactInfo?.mailingState}
                            label="Mailing State"
                            onInputChange={(event) =>
                                setContactInfo(
                                    Object.assign({}, contactInfo, {
                                      mailingState: event.target.value,
                                    })
                                )
                            }
                            errors={errors}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <MUIInput
                            control={control}
                            name="mailingZip"
                            onInputCopy={blockFieldCopy}
                            onInputCut={blockFieldCopy}
                            defaultValue={contactInfo?.mailingZip}
                            inputPrp={{ maxLength: 20 }}
                            value={contactInfo?.mailingZip}
                            label="Mailing Zip"
                            onInputChange={(event) =>
                                setContactInfo(
                                    Object.assign({}, contactInfo, {
                                      mailingZip: event.target.value,
                                    })
                                )
                            }
                            errors={errors}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <MUIInput
                            control={control}
                            name="email"
                            onInputCopy={blockFieldCopy}
                            onInputCut={blockFieldCopy}
                            defaultValue={contactInfo?.email}
                            inputPrp={{ maxLength: 50 }}
                            value={contactInfo?.email}
                            label="Email"
                            onInputChange={(event) =>
                                setContactInfo(
                                    Object.assign({}, contactInfo, {
                                      email: event.target.value,
                                    })
                                )
                            }
                            errors={errors}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <MUIInput
                            control={control}
                            name="emailCopy"
                            onInputCopy={blockFieldCopy}
                            onInputCut={blockFieldCopy}
                            defaultValue={contactInfo?.reEnterEmail}
                            inputPrp={{ maxLength: 50 }}
                            value={contactInfo?.reEnterEmail}
                            label="Reenter Email"
                            onInputChange={(event) =>
                                setContactInfo(
                                    Object.assign({}, contactInfo, {
                                      emailCopy: event.target.value,
                                    })
                                )
                            }
                            errors={errors}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <MUIInput
                            control={control}
                            name="mobilePhone"
                            defaultValue={contactInfo?.mobilePhone}
                            inputPrp={{ maxLength: 10 }}
                            value={contactInfo?.mobilePhone}
                            label="Primary Phone"
                            onInputChange={(event) =>
                                setContactInfo(
                                    Object.assign({}, contactInfo, {
                                      mobilePhone: event.target.value,
                                    })
                                )
                            }
                            errors={errors}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <MUIInput
                            control={control}
                            name="county"
                            defaultValue={contactInfo?.county}
                            inputPrp={{ maxLength: 10 }}
                            value={contactInfo?.county}
                            label="county"
                            onInputChange={(event) =>
                                setContactInfo(
                                    Object.assign({}, contactInfo, {
                                      county: event.target.value,
                                    })
                                )
                            }
                            errors={errors}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <MUIAutoComplete
                            id="country"
                            control={control}
                            name="country"
                            label="Country"
                            errors={errors}
                            value={countryList?.country}
                            onValueChange={(event) =>
                                setContactInfo(
                                    Object.assign({}, contactInfo, {
                                      country: event.target.value,
                                    })
                                )
                            }
                            options={countryList}
                        />
                      </Grid>
                    </>
                )}
              </Grid>
            </CardContent>
            {hasWithdrawn === false &&
            !["Withdrawn", "Completed", "Coverage Found"].includes(
                consumerData.userRequestStatus
            ) &&
            !editContact && (
                <>
                  <CardActions>
                    <Button
                        size="small"
                        color="primary"
                        onClick={() => setEditCoontact(true)}
                        variant="outlined"
                    >
                      Edit Contact Details
                    </Button>
                  </CardActions>
                </>
            )}

            {hasWithdrawn === false &&
            !["withdrawn", "Completed", "Coverage Found"].includes(
                consumerData.userRequestStatus
            ) &&
            editContact && (
                <>
                  <CardActions>
                    <Button
                        size="small"
                        color="primary"
                        type="submit"
                        variant="outlined"
                    >
                      save
                    </Button>
                    &nbsp;
                    <Button
                        size="small"
                        color="secondary"
                        onClick={() => setEditCoontact(false)}
                        variant="outlined"
                    >
                      cancel
                    </Button>
                  </CardActions>
                </>
            )}
          </Card>
        </form>
        <Snackbar
            open={snackBarSettings.show}
            autoHideDuration={6000}
            onClose={handleSnackBarClose}
        >
          <Alert
              variant="filled"
              onClose={handleSnackBarClose}
              severity={snackBarSettings.variant}
          >
            {snackBarSettings.message}
          </Alert>
        </Snackbar>
      </section>
  );
}